import React, { createContext, useContext, useState, ReactNode } from 'react';
import { AppItem } from '@/api/senderId';

interface AppContextType {
  appList: AppItem[];
  selectedAppId: string | undefined;
  setAppList: (apps: AppItem[]) => void;
  setSelectedAppId: (appId: string | undefined) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [appList, setAppList] = useState<AppItem[]>([]);
  const [selectedAppId, setSelectedAppId] = useState<string | undefined>(
    undefined
  );

  return (
    <AppContext.Provider
      value={{
        appList,
        selectedAppId,
        setAppList,
        setSelectedAppId,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within AppProvider');
  }
  return context;
};
